import script from "./AirdropPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AirdropPanel.vue?vue&type=script&setup=true&lang=js"

import "./AirdropPanel.vue?vue&type=style&index=0&id=a666fa32&lang=scss&scoped=true"
script.__scopeId = "data-v-a666fa32"

export default script